const SKIP_TAGS = new Set(['a', 'code', 'pre', 'script', 'style']);

/**
 * Turn bare change slugs (F123, B45, …) into links without mutating stored HTML.
 * Skips text already inside <a>, <code>, <pre>, <script> or <style>.
 */
export function linkifyChangeSlugs(html: string): string {
    if (!html)
        return html;

    let skipDepth = 0;

    return html.replace(/(<\/?[a-zA-Z][^>]*>)|([^<]+)/g, (match, tag?: string, text?: string) => {
        if (tag) {
            const open = tag.match(/^<\s*([a-zA-Z]+)/);
            const close = tag.match(/^<\s*\/\s*([a-zA-Z]+)/);
            const selfClosing = /\/\s*>$/.test(tag);

            if (open && !close) {
                const name = open[1].toLowerCase();
                if (SKIP_TAGS.has(name) && !selfClosing)
                    skipDepth += 1;
            } else if (close) {
                const name = close[1].toLowerCase();
                if (SKIP_TAGS.has(name) && skipDepth > 0)
                    skipDepth -= 1;
            }

            return tag;
        }

        if (!text || skipDepth > 0)
            return text || '';

        // T kept for legacy non-dev slugs; S is the current non-dev prefix.
        return text.replace(/\b([FBCST])(\d+)\b/gi, (slug, _prefix: string, number: string) => (
            `<a href="/changes/by-slug/${number}" data-yoda-change-slug="${number}" class="yoda-change-slug">${slug}</a>`
        ));
    });
}
